import { GlobeAltIcon } from "@heroicons/react/20/solid";

export interface Props {
  link: string;
  text: string;
}

const WebsiteLinkButton = ({ link, text }: Props) => {
  return (
    <a
      className="col-span-2 md:col-span-1 lg:col-span-4 xl:col-span-3 whitespace-nowrap min-w-full md:min-w-fit h-6 md:h-10 flex gap-2 items-center justify-center px-2 py-0.5 text-xs md:text-base xl:text-lg bg-black text-gray-50 hover:bg-cultiv-yellow hover:text-black transition-colors duration-300 ease-in-out"
      href={`${link.includes("http") ? link : `https://${link}`}`}
      target="_blank"
    >
      <p>{text}</p>
      <GlobeAltIcon className="sm:w-6 w-4 sm:h-6 h-4" />
    </a>
  );
};

export default WebsiteLinkButton;
